import Routes from './routes'
import './common.less'
import { secureRouteBuilder } from '../secure-route'
import { ApplicationName } from '@telstra-connect/ops-hub/activity-tracking'
import { OpsHubDashboard } from './pages/ops-hub-dashboard/index-lazy'
import { IApplicationDefinition, IAppRegistry } from '@apps-config/app-definition'
import { RoutesHelper } from '@apps-config/routing/routing'
import { Customer } from './pages/customer/index-lazy'
import { UserCidnAssociation } from './pages/user-cidn-association/index-lazy'
import { UserDetail } from './pages/user-detail/index-lazy'
import { CustomerCustomProps } from './pages/customer-custom-props/index-lazy'
import { UserCustomProps } from './pages/user-custom-props/index-lazy'
import { UserActivationToggle } from './pages/user-activation-toggle/index-lazy'
import { UpdateFeatureFlags } from './pages/update-feature-flags/index-lazy'

const routes = new RoutesHelper({
  rootPath: secureRouteBuilder(''),
  subpagesPathMask: secureRouteBuilder(Routes.OpsHub),
})

const applicationName = ApplicationName;

export const Application: IApplicationDefinition = {
  get applicationName() {
    return applicationName
  },
  get acceptsUserFeedback() {
    return true
  },
  get acceptsErrorReports() {
    return true
  },
  get card() {
    return null
  },
  get routes() {
    return routes
  },
  init(registry: IAppRegistry, availableToUser: boolean) {
    if (availableToUser) {
      registry.add(Application)
    }
  },
  render() {
    return [
      {
        path: routes.getPageSubpath(Routes.opsHubDashboardPageURL),
        component: OpsHubDashboard,
      },
      {
        path: routes.getPageSubpath(Routes.userCidnAssociation),
        component: UserCidnAssociation,
      },
      {
        path: routes.getPageSubpath(Routes.customer),
        component: Customer,
      },
      {
        path: routes.getPageSubpath(Routes.customerCustomProps),
        component: CustomerCustomProps,
      },
      {
        path: routes.getPageSubpath(Routes.userDetails),
        component: UserDetail,
      },
      {
        path: routes.getPageSubpath(Routes.userCustomProps),
        component: UserCustomProps,
      },
      {
        path: routes.getPageSubpath(Routes.userActivationToggle),
        component: UserActivationToggle,
      },
      {
        path: routes.getPageSubpath(Routes.updateFeatureflags),
        component: UpdateFeatureFlags,
      }
    ]
  },
  menuItem() {
    return null
  },
}
export { Routes }
